import { toCatalogRow } from "@ext/enterprise/components/admin/settings/resources/model/CatalogRow";
import type { AvailableCatalog } from "@ext/enterprise/types/AvailableCatalog";
import t from "@ext/localization/locale/translate";
import type { AccessorFnColumnDef } from "@ui-kit/DataTable";
import { TextOverflowTooltip } from "@ui-kit/Tooltip";

export const repoColumnId = "repo";

export interface RepoColumnOptions<T> {
	header?: string;
	catalogs: Map<string, AvailableCatalog>;
	getValue: (item: T) => string;
}

export const repoColumn = <T,>({ header, catalogs, getValue }: RepoColumnOptions<T>): AccessorFnColumnDef<T> => {
	const getRow = (item: T) => {
		const repo = getValue(item);
		return toCatalogRow(repo, catalogs.get(repo));
	};

	return {
		id: repoColumnId,
		accessorFn: (item) => {
			const { title, repo } = getRow(item);
			return `${title} ${repo}`;
		},
		header: header ?? t("name"),
		cell: ({ row }) => <TextOverflowTooltip className="text-sm">{getRow(row.original).title}</TextOverflowTooltip>,
	};
};
